"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nd_modules = exports.np = void 0;
//@ts-check
var _globals_1 = require("../_globals");
var np = _globals_1.GLOBALS.np, _NDArray = _globals_1.GLOBALS.NDArray;
exports.np = np;
if (!np)
    throw new Error("Programming error: np not defined");
exports.nd_modules = _NDArray.prototype.modules;
